import React from "react";
import "../style/loading.css";
import { ReactComponent as Cloud } from "../mediaSvg/cloud.svg";
import { ReactComponent as MediumCloud } from "../mediaSvg/mediumCloud.svg";
import { ReactComponent as LittleCloud } from "../mediaSvg/littleCloud.svg";

function Loading() {
  return (
    <div className="LoadingContainer">
      <div className="cloudsContainer">
        <p className="textCloud">Incoming data...</p>
        <Cloud className="cloud cloudBig" />
        <MediumCloud className="cloud cloudMedium" />
        <LittleCloud className="cloud cloudLittle" />
      </div>
    </div>
  );
}

export default Loading;
